import { Box } from "rebass/styled-components";
import Link from "./Link";
import { LinkProps } from "next/link";

interface Props {
  breadcrumbs: ListItemProps[];
  activeItem: ListItemProps;
}

interface ListItemProps {
  href: LinkProps["href"];
  name: string;
  position: string;
}

const ListItem = ({ name, position, href }: ListItemProps) => {
  return (
    <Box
      as="li"
      itemProp="itemListElement"
      itemScope
      itemType="http://schema.org/ListItem"
      sx={{
        display: "inline-block",
        color: "veryDarkGray"
      }}
    >
      <Link
        href={href}
        itemProp="item"
        css={{
          height: "100%",
          width: "100%"
        }}
      >
        <span itemProp="name">{name}</span>
      </Link>
      <meta itemProp="position" content={position} />
      <Box
        as="span"
        sx={{
          color: "lightgray",
          px: 1
        }}
      >
        &raquo;
      </Box>
    </Box>
  );
};

const ActiveItem = ({ name, position }: ListItemProps) => {
  return (
    <Box
      as="li"
      className="active"
      itemProp="itemListElement"
      itemScope
      itemType="http://schema.org/ListItem"
      sx={{
        color: "gray",
        display: "inline"
      }}
    >
      <span itemProp="name">{name}</span>
      <meta itemProp="position" content={position} />
    </Box>
  );
};

const BreadcrumbList = ({ breadcrumbs, activeItem }: Props) => {
  return (
    <Box
      itemScope
      itemType="http://schema.org/BreadcrumbList"
      as="ul"
      sx={{
        listStyle: "none",
        display: "block",
        fontSize: 1,
        color: "gray",
        pl: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }}
    >
      {breadcrumbs.map((breadcrumb, index) => {
        return <ListItem {...breadcrumb} key={index} />;
      })}
      <ActiveItem {...activeItem} />
    </Box>
  );
};

BreadcrumbList.defaultProps = {};

export default BreadcrumbList;
